import React from "react";

interface PropsInterface {
  className?: string;
  children: React.ReactNode;
}

export const Page = ({ className, children }: PropsInterface) => (
  <div className={`v-page ${className || ''}`}>
    {children}
  </div>
)
